import { css, jsx } from '@emotion/core';
import React from 'react';
import { connect } from 'react-redux';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { bp } from '@/styles';

function Covid19PremiumRefundsAndFilingRequirements(props) {
  return (
    <ContentPage
      {...props}
      bodyStyle={css`
        > div > ul {
          display: block;
          list-style-position: inside;
          @media ${bp.sm} {
            margin-left: 32px;
          }
          > li {
            list-style-type: disc;
          }
        }
      `}
    />
  );
}

export async function getStaticProps() {
  return { props: { sitepageid: 406 } };
}

export default connect(mapStateToProps)(
  withMembershipAccessWrap(Covid19PremiumRefundsAndFilingRequirements)
);
